import { styled } from 'linaria/react';

export const StyledWrap = styled.div`
  .navigation {
    padding-top: 20px;
  }
`;
